import BaseState from "Engine/base/states/BaseState";
import eAnimationTypes from '../enums/eAnimationTypes';

export default class JackpotGameInState extends BaseState {
    async start() {
        OPWrapperService.realityCheck.blockedRealityCheck = true;
        if (!PIXI.Assets.get(eAnimationTypes.EAT_JACKPOT)) {
            OPPreloader.showDelayedPreloader();
            await PIXI.Assets.load(eAnimationTypes.EAT_JACKPOT);
            OPPreloader.hideDelayedPreloader();
        }
        super.start();
        this.complete();
    }
}
